// Bounds for the sync start date picker. The backend enforces a 12-month cap, and a future
// start date would sync nothing — kept here so every picker (InitialSync, Settings) shares one source.

// Earliest start date the backend accepts (12-month cap).
export function getEarliestAllowedDate(): string {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 1);
    return d.toISOString().slice(0, 10);
}

// Today — the start date can only be in the past (a future start date would sync nothing).
export function getTodayDate(): string {
    return new Date().toISOString().slice(0, 10);
}
